import React, { useState } from "react";
import { faQuoteLeft, faQuoteRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faFacebookF,
	faLinkedinIn,
	faTwitter,
	faBehance,
} from "@fortawesome/free-brands-svg-icons";
import DirectorImg from '../../assets/director.jpg'

const teamMembers = [
	{
		picture: "https://cdn.easyfrontend.com/pictures/team/team_square_1.jpeg",
		fullName: " Praveen More",
		designation: "Managing Director",
		bio: "Praveen More brings a wealth of experience in Financial Services Industry. Known for providing personalised solutions for all financial needs, he has successfully managed large Team for corporates Like ICICI, HDFC, Reliance and Kotak. His vision and leadership have driven various project in earlier organisation to create positive delta in sales numbers and establishing new distribution channels. Director has open door policy which allows all his team mates to interact and suggest any improvement areas in the field of business and ensures actions on those suggestions.",
		socialLinks: [
			{ icon: faFacebookF, href: "#" },
			{ icon: faLinkedinIn, href: "#" },
			{ icon: faTwitter, href: "#" },
			// { icon: faBehance, href: "#" },
		],
	},

];

const testimonial = {
	name: "Praveen More",
	content:
		"The more you react,the more to tend to loose it.",
};

const Team = () => {
	const [index, setIndex] = useState(0);
	const { picture, fullName, designation, bio, socialLinks } =
		teamMembers[index];

	const handleControl = (type) => {
		if (type === "prev") {
			setIndex(index <= 0 ? teamMembers.length - 1 : index - 1);
		} else {
			setIndex(index >= teamMembers.length - 1 ? 0 : index + 1);
		}
	};

	const { name, content } = testimonial;

	return (
		<section className="ezy__team8 light overflow-hidden py-14 bg-skyBlue">
			<div>
				<div className="max-w-7xl px-4 mx-auto mt-3">
					<div className="col-span-12 md:col-span-7 mt-5">
						<h1 className="text-3xl font-bold leading-tight md:text-[40px] mb-4 uppercase">
							Director
						</h1>
					</div>
					<div className="flex flex-col md:flex-row">
						<div className="w-full md:w-1/2 md:order-2 flex justify-center items-center">
						<img src={DirectorImg} alt="" srcset="" className="min-h-[450px] w-[50px] md:w-[70%] rounded-lg h-[300px]" />
							{/* <div
								className="bg-center bg-no-repeat bg-contain min-h-[400px] w-full md:w-[80%] h-[200px]"
								style={{
									backgroundImage: `url(https://img.freepik.com/free-photo/3d-illustration-cartoon-business-character-with-round-frame-gray-background_1142-51766.jpg?t=st=1737960135~exp=1737963735~hmac=357f566081b65b08884ff659dbaee630c9935e245eee3f4c78379ff2a4fae910&w=740)`,
								}}
							></div> */}
						</div>
						<div className="w-full md:w-1/2 relative ">
							<div className="pt-3 pb-28 md:py-24 lg:py-10 lg:pr-24 ">
								<h4 className="font-medium text-2xl mb-1">{fullName}</h4>
								<p className="mb-6">{designation}</p>

								<p className="opacity-50 mb-0 leading-7">{bio}</p>
								<div className="mt-6">
									{socialLinks.map((item, i) => (
										<a
											href={item?.href}
											className={`inline-block opacity-60 transition duration-300 hover:translate-y-1 hover:opacity-100 ${i !== socialLinks.length - 1 && "mr-4"
												}`}
											key={i}
										>
											<FontAwesomeIcon icon={item.icon} />
										</a>
									))}
								</div>
							</div>



						</div>
					</div>
					<div className=" lg:mt-20">
						<p className="relative text-xl md:text-[26px] leading-10 font-bold mb-6 md:mb-12 text-center z-[1]">
							<FontAwesomeIcon
								icon={faQuoteLeft}
								className="absolute -top-3 left-0 md:-top-1/2 text-[20px] md:text-[100px] text-darkBlue -z-[1]"
							/>
							{content}
							<FontAwesomeIcon
								icon={faQuoteRight}
								className="absolute -bottom-3 right-0 md:-bottom-1/2 text-[20px] md:text-[100px] text-darkBlue -z-[1]"
							/>
						</p>
						<div className="text-center">
							<div>
								<h4 className="text-xl font-medium mb-2">- {name}</h4>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Team;